module.exports = __webpack_public_path__ + "frontend/assets/img/yellow-pencils.jpg";